import { formatText } from 'core/i18n';
import { SNACKBAR_TYPE } from 'componentsV2/SnackBar/SnackBar';
import { MESSAGEBOX_TYPE } from '../../fields/OTP/constants';

export const EmailOTPValidationInitialStep = {
    isOTPValidated: false,
    isEmailValidated: false,
    shouldShowInvalidatedEmailMessage: false,
    retryOTPCounter: 0,
    errorMessage: '',
    messageBox: {
        type: '',
        text: '',
    },
    snackBar: {
        type: '',
        text: '',
    },
};

export const EmailOTPValidationActions = {
    RESET_EMAIL_OTP_VALIDATION: 'RESET_EMAIL_OTP_VALIDATION',
    RESET_OTP_STATUS: 'RESET_OTP_STATUS',
    VALIDATE_EMAIL: 'VALIDATE_EMAIL',
    INVALID_EMAIL: 'INVALID_EMAIL',
    MODIFY_EMAIL: 'MODIFY_EMAIL',
    VALIDATE_OTP: 'VALIDATE_OTP',
    RETRY_OTP_SUCCESS: 'RETRY_OTP_SUCCESS',
    RETRY_OTP_FAILURE: 'RETRY_OTP_FAILURE',
    RETRY_OTP_LIMIT: 'RETRY_OTP_LIMIT',
    OTP_INCORRECT: 'VALIDATE_OTP_INCORRECT',
    OTP_INCORRECT_RETRY: 'VALIDATE_OTP_INCORRECT_RETRY',
    OTP_INCORRECT_NO_RETRY: 'VALIDATE_OTP_INCORRECT_NO_RETRY',
    OTP_EXPIRED_RETRY: 'VALIDATE_EXPIRED_RETRY',
    OTP_EXPIRED_NO_RETRY: 'VALIDATE_EXPIRED_NO_RETRY',
    CHANGE_OTP_VALIDATION: 'CHANGE_OTP_VALIDATION',
    FIELD_REQUIRED: 'FIELD_REQUIRED',
    GENERIC_ERROR: 'GENERIC_ERROR',
    RESET_SNACKBAR: 'RESET_SNACKBAR',
};

export function EmailOTPValidationReducer(state, action) {
    switch (action.type) {
        case EmailOTPValidationActions.RESET_OTP_STATUS:
            return {
                ...state,
                isOTPValidated: EmailOTPValidationInitialStep.isOTPValidated,
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.VALIDATE_EMAIL:
            return {
                ...state,
                isEmailValidated: true,
                shouldShowInvalidatedEmailMessage: false,
                retryOTPCounter: EmailOTPValidationInitialStep.retryOTPCounter,
            };
        case EmailOTPValidationActions.MODIFY_EMAIL:
            return {
                ...state,
                isEmailValidated: EmailOTPValidationInitialStep.isEmailValidated,
                isOTPValidated: EmailOTPValidationInitialStep.isOTPValidated,
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.INVALID_EMAIL:
            return {
                ...state,
                errorMessage: formatText('otpEmailValidation-sameEmailWarning'),
            };
        case EmailOTPValidationActions.VALIDATE_OTP:
            return {
                ...state,
                isOTPValidated: true,
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.OTP_INCORRECT:
            return {
                ...state,
                errorMessage: formatText('otpEmailValidation-incorrectCode'),
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.OTP_INCORRECT_RETRY:
            return {
                ...state,
                messageBox: {
                    type: MESSAGEBOX_TYPE.ERROR,
                    text: formatText('otpEmailValidation-wrongCode3Times'),
                },
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.OTP_INCORRECT_NO_RETRY:
            return {
                ...state,
                isEmailValidated: false,
                shouldShowInvalidatedEmailMessage: true,
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.OTP_EXPIRED_RETRY:
            return {
                ...state,
                messageBox: {
                    type: MESSAGEBOX_TYPE.ERROR,
                    text: formatText('otpEmailValidation-codeExpired'),
                },
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.OTP_EXPIRED_NO_RETRY:
            return {
                ...state,
                errorMessage: formatText('validation-otpAllTriesMade'),
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.RETRY_OTP_SUCCESS:
            return {
                ...state,
                retryOTPCounter: state.retryOTPCounter + 1,
                snackBar: {
                    type: SNACKBAR_TYPE.SUCCESS,
                    text: formatText('otpEmailValidation-checkSpamFolder2'),
                },
                isOTPValidated: EmailOTPValidationInitialStep.isOTPValidated,
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                messageBox: EmailOTPValidationInitialStep.messageBox,
            };

        case EmailOTPValidationActions.RETRY_OTP_FAILURE:
            return {
                ...state,
                retryOTPCounter: state.retryOTPCounter + 1,
                isOTPValidated: EmailOTPValidationInitialStep.isOTPValidated,
                snackBar: {
                    type: SNACKBAR_TYPE.ERROR,
                    text: formatText('otpEmailValidation-errorSendingEmail'),
                },
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                messageBox: EmailOTPValidationInitialStep.messageBox,
            };
        case EmailOTPValidationActions.RETRY_OTP_LIMIT:
            return {
                ...state,
                messageBox: {
                    type: MESSAGEBOX_TYPE.WARNING,
                    text: formatText('otpEmailValidation-maxRetryEmail'),
                },
                errorMessage: EmailOTPValidationInitialStep.errorMessage,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.CHANGE_OTP_VALIDATION:
            return {
                ...state,
                isOTPValidated: action.payload.isOTPValidated,
            };
        case EmailOTPValidationActions.FIELD_REQUIRED:
            return {
                ...state,
                errorMessage: formatText('validation-fieldRequired'),
            };

        case EmailOTPValidationActions.GENERIC_ERROR:
            return {
                ...state,
                errorMessage: formatText('otpEmailValidation-genericError'),
                messageBox: EmailOTPValidationInitialStep.messageBox,
                snackBar: EmailOTPValidationInitialStep.snackBar,
            };
        case EmailOTPValidationActions.RESET_SNACKBAR:
            return {
                ...state,
                snackBar: {
                    type: EmailOTPValidationInitialStep.snackBar.type,
                    text: EmailOTPValidationInitialStep.snackBar.text,
                },
            };
        case EmailOTPValidationActions.RESET_EMAIL_OTP_VALIDATION:
            return EmailOTPValidationInitialStep;
        default:
            throw new Error();
    }
}
